import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'
import { deletePoll } from '../services/topicService'

/* eslint-disable import/no-internal-modules */
import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
} from '@insided/deprecated-preact-components/design-system-components/modal'
import { ButtonGroup } from '@insided/deprecated-preact-components/design-system-components/button'

export interface DeletePollModalProps {
  contentType: ContentType
  topicId: number
  onPollUpdate: (poll: { question: string, options: string[] }) => void
  onTogglePollEditor: (show: boolean) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  onClose: () => void
}

export interface DeletePollModalState {
  isLoading: boolean
}

class DeletePollModal extends PureComponent<DeletePollModalProps, DeletePollModalState> {
  constructor(props: DeletePollModalProps) {
    super(props)
    this.onDeletePoll = this.onDeletePoll.bind(this)
  }

  async onDeletePoll() {
    const { contentType, topicId, onShowAlert, onPollUpdate, onTogglePollEditor, onClose } = this.props
    try {
      await deletePoll(contentType, topicId)
      onPollUpdate({ question: '', options: [] })
      this.setState({ isLoading: false })
      onClose()
      onTogglePollEditor(false)
      onShowAlert('success', 'Poll successfully deleted')
    } catch {
      onShowAlert('error', 'Something went wrong, please try again later.')
    }
    this.setState({ isLoading: false })
  }

  render() {
    const { onClose } = this.props
    const { isLoading } = this.state
    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title='Are you sure you want to delete the poll permanently?' />
        <ModalBody>
          <p>The poll will not be visible in the topic anymore.</p>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              title='Delete poll'
              variant='warning'
              onClick={this.onDeletePoll}
              isLoading={isLoading}
              data-qa='delete-poll'
              size='medium'
            />
            <Button title='Cancel' onClick={onClose} size='medium' />
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default DeletePollModal
